import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

const MatchupContainer = styled.div`
    width: 100%;
    padding: 10px;
    border-bottom: 1px solid ${({ theme }) => theme.Surface.border};
    display: flex;
    align-items: center;
    -webkit-font-smoothing: antialiased;
`;

const LogoContainer = styled.div`
    width: 96px;
    height: 64px;
    display: inline-block;
    vertical-align: middle;
`;

const TeamContainer = styled.div`
    text-align: center;
    flex: 1;
    max-width: 200px;

    ${BaseStyle.Mixins.screenSizes.large} {
        direction: ${(props) => (props.homeTeam ? 'ltr' : 'rtl')};
        max-width: 500px;
    }
`;

const TeamName = styled.div`
    display: inline-block;
    vertical-align: middle;

    text-transform: uppercase;
    font-family: HelveticaNeue, Helvetica, Arial, sans-serif;
    font-size: 13px;
    font-weight: bold;
`;

const ScoreboardContainer = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
    font-weight: bold;
    justify-content: center;
    ${BaseStyle.Mixins.gaps.small};
    margin: 0 auto;
    text-align: center;
`;

const ScoreDisplay = styled.span`
    ${BaseStyle.Mixins.fontStyles.ui['32b']};
    display: inline-block;
    height: 24px;

    ${BaseStyle.Mixins.screenSizes.large} {
        ${BaseStyle.Mixins.fontStyles.ui['48b']};
        height: 50px;
    }
`;

const GameState = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14m']};
    display: inline-block;
    text-align: center;
    vertical-align: bottom;
    margin-left: 10px;
    margin-right: 10px;

    ${BaseStyle.Mixins.screenSizes.large} {
        margin-left: 15px;
        margin-right: 15px;
    }
`;

const GameStateTime = styled.span`
    ${BaseStyle.Mixins.fontStyles.ui['14m']};
    display: block;

    ${BaseStyle.Mixins.screenSizes.large} {
        ${BaseStyle.Mixins.fontStyles.ui['18m']};
    }
`;

export {
    MatchupContainer,
    LogoContainer,
    TeamContainer,
    TeamName,
    ScoreboardContainer,
    ScoreDisplay,
    GameState,
    GameStateTime,
};
